// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"500":"18d506d3","720":"e3cf7904","962":"f53b8e42"}[chunkId] + ".chunk.css";
};